export const openCollectionDirectlyPreferenceKey =
  'OPEN_COLLECTION_INSTEAD_OF_MANAGE_CONTENT_PANEL_PREFERENCE_KEY'

export const openMultilingualDirectlyPreferenceKey =
  'OPEN_MULTILINGUAL_INSTEAD_OF_MANAGE_CONTENT_PANEL_PREFERENCE_KEY'

export enum CollectionIds {
  INQUIRY_SERVICES = 'Services/InquiryService',
}
